module.exports = __webpack_public_path__ + "img/productbg.d64e6822.png";